import { getCountryCode } from '~/utils/getGeoInfo'

const priceCapPerCountry = {
  NL: 120,
  DK: 100,
  FR: 100,
  PT: 100,
  NO: 100,
  BE: 100,
  AU: 110,
  BR: 100,
}

module.exports = () => {
  const country = getCountryCode()
  const priceCap = priceCapPerCountry[country]

  return priceCap || 120
}
